import {
  GET_LESSONS,
  GET_LESSONS_LIST,
  GET_LESSONS_MINIMAL,
  GET_LESSON,
  ADD_LESSON,
  DELETE_LESSON,
  UPDATE_LESSON,
  LESSONS_LOADING,
  LESSON_LOADING,
  CLEAR_CURRENT_LESSON,
  SET_LESSONS_PAGE
} from '../actions/types';

const initialState = {
  lessons: [],           // Lightweight list for table
  minimalLessons: [],    // Ultra-lightweight list for dropdowns (only _id and title)
  currentLesson: null,   // Full lesson data for view/edit pages
  loading: false,        // For list loading
  lessonLoading: false,  // For single lesson loading
  currentPage: 1,        // Current page number
  totalPages: 0,         // Total number of pages
  totalLessons: 0,       // Total number of lessons
  hasNextPage: false,    // Whether there's a next page
  hasPrevPage: false     // Whether there's a previous page
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_LESSONS_MINIMAL:
      return {
        ...state,
        minimalLessons: action.payload,
        loading: false
      };

    case GET_LESSONS_LIST:
      return {
        ...state,
        lessons: action.payload.lessons || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalLessons: action.payload.totalLessons || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_LESSON:
      return {
        ...state,
        currentLesson: action.payload,
        lessonLoading: false
      };

    case LESSON_LOADING:
      return { ...state, lessonLoading: true };

    case CLEAR_CURRENT_LESSON:
      return { ...state, currentLesson: null, lessonLoading: false };

    case ADD_LESSON:
      return {
        ...state,
        // Add lightweight version to list
        lessons: [
          {
            _id: action.payload._id,
            title: action.payload.title,
            tags: action.payload.tags,
            createdAt: action.payload.createdAt,
            updatedAt: action.payload.updatedAt
          },
          ...state.lessons
        ],
        currentLesson: action.payload
      };

    case UPDATE_LESSON:
      return {
        ...state,
        // Update in list
        lessons: state.lessons.map(lesson =>
          lesson._id === action.payload._id
            ? {
                _id: action.payload._id,
                title: action.payload.title,
                tags: action.payload.tags,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt
              }
            : lesson
        ),
        currentLesson: action.payload
      };

    case DELETE_LESSON:
      return {
        ...state,
        lessons: state.lessons.filter(lesson => lesson._id !== action.payload),
        currentLesson: null
      };

    case LESSONS_LOADING:
      return { ...state, loading: true };

    case GET_LESSONS: // Keep for backward compatibility
      return { ...state, lessons: action.payload, loading: false };

    case SET_LESSONS_PAGE:
      return { ...state, currentPage: action.payload };

    default:
      return state;
  }
}
